import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "./components/Layout";
import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Checkout from "./pages/Checkout";
import MapPage from "./pages/MapPage";
import FindUs from "./pages/FindUs";
import Shop from "./pages/Shop";
import ShopCategory from "./pages/ShopCategory";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Wishlist from "./pages/Wishlist";
import AccountLayout from "./pages/AccountLayout";
import Profile from "./pages/Profile";
import Orders from "./pages/Orders";
import OrderDetail from "./pages/OrderDetail";
import OrderTrack from "./pages/OrderTrack";
import Addresses from "./pages/Addresses";
import CheckoutFlow from "./pages/CheckoutFlow";
import OrderSuccess from "./pages/OrderSuccess";
import CmsPage from "./pages/CmsPage";
import DriverLayout from "./pages/driver/DriverLayout";
import DriverDashboard from "./pages/driver/DriverDashboard";
import DriverInventory from "./pages/driver/DriverInventory";
import DriverOrders from "./pages/driver/DriverOrders";
import DriverOrderDetail from "./pages/driver/DriverOrderDetail";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminOrderDetail from "./pages/admin/AdminOrderDetail";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminInventory from "./pages/admin/AdminInventory";
import AdminCoupons from "./pages/admin/AdminCoupons";
import AdminFleet from "./pages/admin/AdminFleet";
import AdminMarketing from "./pages/admin/AdminMarketing";
import AdminReports from "./pages/admin/AdminReports";
import AdminCms from "./pages/admin/AdminCms";
import AdminStaff from "./pages/admin/AdminStaff";
import PublicTrack from "./pages/PublicTrack";

export default function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <CartProvider>
          <WishlistProvider>
            <Routes>
              {/* Public tracking — no storefront chrome, no auth */}
              <Route path="/track/:token" element={<PublicTrack />} />

              {/* Driver shell (no storefront chrome) */}
              <Route path="/driver" element={<DriverLayout />}>
                <Route index element={<DriverDashboard />} />
                <Route path="dashboard" element={<DriverDashboard />} />
                <Route path="inventory" element={<DriverInventory />} />
                <Route path="orders" element={<DriverOrders />} />
                <Route path="orders/:order_no" element={<DriverOrderDetail />} />
              </Route>

              {/* Admin shell (no storefront chrome) */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="orders/:order_no" element={<AdminOrderDetail />} />
                <Route path="customers" element={<AdminCustomers />} />
                <Route path="inventory" element={<AdminInventory />} />
                <Route path="coupons" element={<AdminCoupons />} />
                <Route path="fleet" element={<AdminFleet />} />
                <Route path="marketing" element={<AdminMarketing />} />
                <Route path="reports" element={<AdminReports />} />
                <Route path="cms" element={<AdminCms />} />
                <Route path="staff" element={<AdminStaff />} />
              </Route>

              {/* Storefront shell */}
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/poc/checkout" element={<Checkout />} />
                <Route path="/poc/map" element={<MapPage />} />
                <Route path="/find-us" element={<FindUs />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/:category" element={<ShopCategory />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/checkout" element={<CheckoutFlow />} />
                <Route path="/order/:order_no/success" element={<OrderSuccess />} />
                <Route path="/order/:order_no/track" element={<OrderTrack />} />
                <Route path="/account" element={<AccountLayout />}>
                  <Route index element={<Profile />} />
                  <Route path="orders" element={<Orders />} />
                  <Route path="orders/:order_no" element={<OrderDetail />} />
                  <Route path="addresses" element={<Addresses />} />
                </Route>
                <Route path="/about" element={<CmsPage />} />
                <Route path="/contact" element={<CmsPage />} />
                <Route path="/privacy" element={<CmsPage />} />
                <Route path="/terms" element={<CmsPage />} />
                <Route path="/shipping" element={<CmsPage />} />
                <Route path="/returns" element={<CmsPage />} />
                <Route
                  path="*"
                  element={
                    <div
                      data-testid="not-found"
                      className="max-w-3xl mx-auto px-6 py-32 text-center"
                    >
                      <p className="label-overline text-jow-gold">404</p>
                      <h1 className="font-display text-5xl mt-3 text-jow-navy">
                        This page is off the route.
                      </h1>
                      <p className="mt-3 text-jow-navy/60">
                        Our rikshaws don't stop here.
                      </p>
                    </div>
                  }
                />
              </Route>
            </Routes>
          </WishlistProvider>
        </CartProvider>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#FFF8F0",
            border: "1px solid rgba(212,175,55,0.4)",
            color: "#0A1F44",
            fontFamily: "Inter, sans-serif",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}
